export default {
  uploadArea: {
    padding: '32px 40px',
    borderRadius: '16px',
    backgroundColor: (theme) => theme.palette.blues.lightestBlue,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  uploadAreaWithBackGround: (backgroundImage) => {
    return {
      // zIndex: 1000,
      borderRadius: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      height: backgroundImage && '168px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundImage,
    };
  },
  uploadAreaText: {
    fontSize: '0.875rem',
    fontWeight: '500',
    maxWidth: '182px',
    textAlign: 'center',
    color: (theme) => theme.palette.blues.primaryBlue500,
  },
  uploadAreaIcon: {
    position: 'relative',
    backgroundColor: (theme) => theme.palette.blues.primaryBlue,
    width: '36px',
    height: '36px',
    margin: '-18px auto 0',
    borderRadius: '8px',
    backgroundImage: "url('/images/plusIcon.svg')",
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  uploadAreaButton: {
    position: 'relative',
    backgroundColor: (theme) => theme.palette.blues.primaryBlue,
    color: (theme) => theme.palette.white.paper,
    width: '74px',
    height: '41px',
    padding: '10px',
    fontSize: '14px',
    textAlign: 'center',
    margin: '-18px auto 0',
    borderRadius: '8px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  icon: {
    fontSize: '50px',
    color: (theme) => theme.palette.blues.primaryBlue200,
  },
  replace: {
    position: 'relative',
    backgroundColor: (theme) => theme.palette.blues.primaryBlue,
    margin: '-18px auto 0',
    borderRadius: '8px',
    backgroundImage: "url('/images/plusIcon.svg')",
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
};
